<img loading="lazy" alt="" height="1" width="1" src="https://cdn.ciphersports.io/images/flagsquares/{{ countryCode }}.png">